import { render, staticRenderFns } from "./HumitureBarChart.vue?vue&type=template&id=3b09a6b9&scoped=true&"
import script from "./HumitureBarChart.vue?vue&type=script&lang=js&"
export * from "./HumitureBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b09a6b9",
  null
  
)

export default component.exports